<template>
  <a-modal
    :mask="false"
    class="set-default-account-book"
    :width="720"
    title="默认设置"
    :visible="visible"
    @cancel="onCancel"
    @ok="onConfirm"
  >
    <a-form-model
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-form-model-item :label="label">
        <!--  -->
        <multi-select v-if="type==='isFins'" v-model="accountBook" style="width: 320px" type="default_accountBook" />
        <multi-select
          v-else-if="type==='isFas'"
          v-model="company"
          :dropdownMatchSelectWidth="true"
          :params="{userType: 'USER'}"
          width="320"
          type="default_company"
          />
      </a-form-model-item>
    </a-form-model>
    <div style="height: 200px"></div>
  </a-modal>
</template>

<script>
import { axios } from '@/utils/request'
import MultiSelect from './multi-select'
import { actions } from '@/microAppsConfig'
export default {
  name: 'SetDefaultAccountBook',
  components: {
    MultiSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'isFins'
    }
  },
  data() {
    return {
      accountBook: {},
      company: {}
    }
  },
  watch: {
    visible(val) {
      if (val) {
        switch (this.type) {
          case 'isFins':
            this.accountBook = { ...this.$store.state.user.default_account_book }
            break
          case 'isFas':
            this.company = { ...this.$store.state.user.default_company }
            break
          default:
            break
        }
      }
    }
  },
  computed: {
    label() {
      let label
      switch (this.type) {
        case 'isFins':
          label = '默认财务核算账簿'
          break
        case 'isFas':
          label = '默认公司'
          break
        default:
          break
      }
      return label
    }
  },
  methods: {
    // 确认 保存
    onConfirm() {
      const { id, code, name, companyId, companyName } = this.accountBook || {}
      const data = id ? { defaultCompanyId: companyId } : { defaultCompanyId: 0 }
      const accountBook = id ? { id, code, name, companyId, companyName } : {}
      const companyData = this.company && this.company.id ? { defaultCompanyId: this.company.id } : { defaultCompanyId: 0 }

      switch (this.type) {
        case 'isFins':
          axios.post('/finsaas-gls/sysUser/updateBySelf', data).then(res => {
            if (+res.code === 0) {
              this.$message.success('默认财务核算账簿设置成功')
              this.onCancel()
              this.$store.commit('setAccountBook', accountBook)
              actions.setGlobalState({ accountBook })
            }
          }).catch(console.log)
          break
        case 'isFas':
          // if (!this.company || !this.company.id) {
          //   this.$message.error('请先选择默认公司')
          //   return
          // }
          axios.post('/finsaas-fixed-asset/sys-user/update-default-company', companyData).then(res => {
            if (+res.code === 0) {
              this.$message.success('默认公司设置成功')
              this.onCancel()
              this.$store.commit('setDefaultCompany', this.company)
              actions.setGlobalState({ defaultCompany: this.company })
            }
          })
          break
        default:
          break
      }
    },
    // 取消
    onCancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less">
.set-default-account-book {
  .ant-modal-body {
    padding: 40px 16px 12px;
    height: 406px;
  }
  .ant-modal-footer {
    padding: 11px 16px;
    .ant-btn {
      height: 32px;
      padding: 0 17px;
      line-height: 30px;
    }
  }
}
</style>
